import { http } from "../../../config/HttpMethod";
import { ESP_ENDPOINTS } from "../endpoints";

export const fetchEquipmentsForAboveESP = async (payload: any) => {
    const params = {
        series: payload?.series,
        catalogFilter: payload?.catalogFilter
    }
    try {
        const response = await http.get(`${ESP_ENDPOINTS?.GET_SR_ABOVE_ESP}`, { params });
        return response?.data;
    } catch (error) {
        console.error(error);
    }
};

export const fetchEquipmentsForBelowESP = async (payload: any) => {
    const params = {
        catalogFilter: payload?.catalogFilter
    }
    try {
        const response = await http.get(`${ESP_ENDPOINTS?.GET_SR_BELOW_ESP}`, { params });
        return response?.data;
    } catch (error) {
        console.error(error);
    }
};